import { ManfrediteCvApplication } from '@asgard/common-dto';
import {
  PublicManfrediteJobApplication,
  PublicManfrediteJobApplicationResume
} from 'interfaces/manfredite.interface';
import { PublicManfredite } from 'interfaces/public-manfredite.interface';

export enum CVApplicationViewActionType {
  ACCEPT_TERMS = 'ACCEPT_TERMS'
}

type CVApplicationViewAction = {
  type: CVApplicationViewActionType.ACCEPT_TERMS;
  payload: {
    data: PublicManfrediteJobApplication;
  };
};

type CVApplicationViewState = {
  termsAndConditionsAccepted: boolean;
  publicManfredite?: PublicManfredite | null;
  cvApplication?: ManfrediteCvApplication | null;
  jobApplicationResume: PublicManfrediteJobApplicationResume;
};

export default function CVApplicationViewReducer(
  state: CVApplicationViewState,
  action: CVApplicationViewAction
): CVApplicationViewState {
  const { type, payload } = action;

  switch (type) {
    case CVApplicationViewActionType.ACCEPT_TERMS:
      return {
        ...state,
        termsAndConditionsAccepted: true,
        publicManfredite: payload.data.publicManfredite,
        cvApplication: payload.data.jobApplication
      };

    default:
      throw new Error(
        `Invalid action type must be any of: ${Object.values(
          CVApplicationViewActionType
        )}`
      );
  }
}
